import React from "react";

export const UnitsView = () => {
  return <div>index</div>;
};
